import { mapGetters, mapActions } from 'vuex';
import localStorage from '@/components/Services/storage';
import { RESEND_COUNTDOWN_DURATION, SMS_STATE_KEY } from '@/constants/auth';
import normalizeAustrianPhone from '@/services/phone';

export default {
    data() {
        return {
            phoneNumber: '',
            isLoading: false,
        };
    },

    computed: {
        ...mapGetters({
            user: 'user/user',
        }),
    },

    methods: {
        ...mapActions('user', ['attemptToGetSmsCodeViaMsisdn', 'restoreSmsState']),
        handleSendSms() {
            // Normalize to the "43" country-code form before sending / comparing.
            const phone = normalizeAustrianPhone(this.phoneNumber);

            // Check if a valid countdown exists for this phone number
            const smsStateStr = localStorage.get(SMS_STATE_KEY, true);
            if (smsStateStr) {
                try {
                    const smsState = JSON.parse(smsStateStr);
                    const elapsedSeconds = Math.floor((Date.now() - smsState.lastSentTime) / 1000);

                    if (smsState.codeSent && smsState.userId && smsState.phone === phone &&
                        elapsedSeconds < RESEND_COUNTDOWN_DURATION) {
                        // Countdown still active for same number - restore without sending new SMS
                        this.restoreSmsState({
                            userId: smsState.userId,
                            isSmsCodeSent: true,
                            phoneNumber: phone,
                        });
                        return;
                    }
                } catch (e) {
                    console.error('Failed to parse SMS state:', e);
                    localStorage.remove(SMS_STATE_KEY);
                }
            }

            this.isLoading = true;
            this.attemptToGetSmsCodeViaMsisdn({ phone })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },

    mounted() {
        this.$refs.phoneNumberInput.focus();
    },
};
